export default __webpack_public_path__ + "static/media/accounts.9db24cee.svg";